import { ColorSet } from "../components/colorSelect/ColorSelect";

// メッセージ
export module ConstMessage {
    export const WARN_REGISTED_ADMIN_EMAIL = '登録済のメールアドレスです。';
    export const ERR_UNSUPPORT_IMG_FILE_TYPE = 'JPEG または PNG ファイルを選択してください。';
    export const ERR_INPUT_KANA_ALPHA_NUM = 'カナ英数字で入力してください。';
    export const ERR_USERID_LENGTH = '11桁で入力して下さい。';
    export const ERR_DIFFERENT_TENANT_ID = '団体番号が異なります。';
    export const ERR_FORMAT_USER_IMPORT_FILE = '正しいファイルをアップロードしてください。';
    export const ERR_APP_AVAILABLE_OVER_USER_IMPORT_FILE = 'アプリ利用可能数が契約数を上回っています。\n　アプリ利用可能数が契約数以下になるように設定してください。';
    export const ERR_CONNECT_TO_NETWORK = 'ネットワークに接続できません。';
    export const ERR_SAVE = '保存に失敗しました。';
    export const ERR_INVALID_GROUP = 'グループが「無効」のため、編集できません。';
    export const SUCCESS_SAVE_ADMINFLG = '管理者を保存しました。';
    export const ERR_ONLINE_URLS_DUPLICATION = 'このミーティングURL名は既に登録されています。';
    export const ERR_LINK_MENUS_DUPLICATION = 'この連携アプリ名は既に登録されています。';
    export const SUCCESS_SAVE_GROUPSUSER = 'グループユーザを保存しました。';
    export const PROGRESS_SUB_TEXT = 'この処理は時間がかかる場合があります。';
    export const IMPORT_ERR_DATA_DIFF = '停止済利用者の情報変更不可';
    export const IMPORT_ERR_CAN_NOT_SETTING_ACCOUNT_SUSPENSION = '停止設定不可';
    export const IMPORT_ERR_INVALID_VALUE = '無効の入力値';
    export const IMPORT_ERR_UNREGISTERED_VALUE = '未登録の入力値';
    export const IMPORT_ERR_OVERLIMITGROUP_VALUE = '所属人数上限（最大1000人）';
    export const IMPORT_ERR_REQUIRED_FIELD = '必須項目';
    export const IMPORT_ERR_INVALID_FORMAT = '無効のフォーマット';
    export const IMPORT_ERR_NOT_FOUND_USER = '対象者なし';
    export const IMPORT_ERR_MSG = 'インポートに失敗しました。';
    export const IMPORT_SUCCESS_DIALOG_TITLE = '登録が完了しました';
    export const IMPORT_SUCCESS_DIALOG_TEXT = '%1件をExcelから登録しました。';
    export const IMPORT_FAILED_DIALOG_TITLE = '登録が完了しましたが一部エラーがあります';
    export const IMPORT_FAILED_ALL_DIALOG_TITLE = '登録にエラーがあります';
    export const IMPORT_NO_DATA_TITLE = '登録データがありませんでした';
    export const IMPORT_FAILED_DIALOG_TEXT = '%1件の登録が成功しましたが、%2件の登録が失敗しています。';
    export const IMPORT_FAILED_DIALOG_TEXT_WORNING = "登録が失敗した内容についてはファイルをダウンロードし\nその内容を再確認してください。";
    export const ERR_LOGIN_INFO_PDF_DOWNLOAD = "ログイン情報PDFのダウンロードに失敗しました。";
    export const ERR_LOGIN_INFO_PDF_LAST_NAME = "値が設定されていません。\n 1文字以上設定してください。";
    export const ERR_LOGIN_INFO_PDF_ADMIN = "値が設定されていません。\n「利用者」または「運営者」を設定してください。";
    export const ERR_LOGIN_INFO_PDF_DELETE_FLG = "値が設定されていないか、「不可」または「停止」に設定されています。\n「不可」「停止」の場合はダウンロードできません。\n必要な場合は確認後「可能」に設定してください。";
    export const IMPORT_ERR_DATE_TIME_SETTING = '配信日より過去日';
    export const IMPORT_ERR_DATE_TIME_PASTDATE = '登録日より過去日';
    export const IMPORT_ERR_DATE_TIME_PUB_END = '掲載終了日より未来日';
    export const IMPORT_ERR_TIME_BEFORE_SEND = '配信日（時分）以前の時間';
    export const IMPORT_ERR_TIME_BEFORE_EVENT_START = '開始時間以前の時間';
    export const IMPORT_SUCCESS_MESSAGE_DIALOG_TITLE = '%1の登録が完了しました';
    export const IMPORT_FAILED_MESSAGE_DIALOG_SUB_TEXT = '登録した%1は下書きのため、\n各%2の詳細画面より配信してください。';
    export const IMPORT_FAILED_MESSAGE_DIALOG_TITLE = '%1の登録が完了しましたが一部エラーがあります';
    export const IMPORT_FAILED_ALL_MESSAGE_DIALOG_TITLE = '%1の登録にエラーがあります';
    export const IMPORT_FAILED_ALL_DIALOG_TEXT = '%1件の登録が失敗しています。';
    export const ERR_LOGIN_INFO_PDF_BULK_DOWNLOAD = "ファイル名「%1」のログイン情報PDFのダウンロードに失敗しました。";
    export const ERR_LOGIN_INFO_PDF_RECREATE = "ログイン情報PDFの再作成に失敗しました。";
    export const ERR_FAILED_GET_DATA = 'データの取得に失敗しました。';
    export const ERR_REGISTERED_REPLY_BUTTONS_NAME = 'この設定名は既に登録されています。';
    export const SUCCESS_SAVE_REPLY_BUTTONS = 'ボタンを保存しました。';
    export const SUCCESS_DELETE_REPLY_BUTTONS = '削除しました。';
    export const ERR_FAILURE_TO_NETWORK_CONNECTION = 'ネットワークに接続できません。';
    export const ERR_FAILURE_TO_SAVE_REPLY_BUTTONS = '保存に失敗しました。';
    export const ERR_NOT_REGISTERED_DATA = '登録済の値を入力してください。';
    export const INPUT_ERR_LINK_MENU_NAME_LINE = '3行以下で入力してください。';
    export const INPUT_ERR_LINK_MENU_NAME_COUNT = '1行につき10文字以内で入力してください。';
    export const ERR_ZIP_CODE_INVALID_FORMAT = '正しいフォーマット(xxx-xxxx)で入力してください。';
    export const ERR_BIRTH_DATE_INVALID_FORMAT = '日付形式で入力してください。';
    export const ERR_IMPUT_DATE_THAN_AFTER = '%1より後でなければなりません。';
    export const ERR_NOT_INPUT = '必ず入力してください。';
    export const ERR_GROUP_SELECT_31_OR_MORE = '一度に選択可能なグループ数は30件までです。'
    export const ERR_SAME_VALUE = '同じ値を設定することはできません。'
    export const ERR_NON_NUMERIC = '数値を入力してください。'
    export const ERR_DISPLAY_ORDER_RANGE = '0～999の範囲で入力してください。'
    export const MSG_OPERATION_NOT_POSSIBLE_NO_GROUPADMIN = "管理者を設定していないグループはイベントサポートから操作できません。";
    export const MSG_IF_GROUPADMIN_ISNOT_SET = "管理者が未設定の場合、イベントサポートからグループに対する操作はできません。";
    export const ERR_FILE_EXPORT_ERROR = 'エラーファイルの作成に失敗しました。'
    export const ERR_MONTHLY_UPPER_LIMIT = '今月は既に%1回依頼済みのため申請できません。';
    export const ERR_UPPER_LIMIT = '※カードの合計が%1枚以上になるためアップロードできません。';
    export const IMPORT_ERR_INVALID_USER_NUMBER = '存在しない利用者番号';
    export const IMPORT_ERR_NOT_FOUND_USER_NAME = '利用者名が設定されていない利用者番号';
    export const IMPORT_EXCEL_SUCCESS_DIALOG_TEXT = 'Excelファイルのアップロードが完了しました。';
    export const IMPORT_EXCEL_FAILED_DIALOG_TEXT = 'Excelファイルのアップロードが失敗しました。';
    export const IMPORT_FAILED_USER_NUMBER_DIALOG_TEXT = '※利用者番号にエラーがあります。';
    export const IMPORT_APPLOAD_FAILED_DIALOG_TEXT_WORNING = 'アップロードが失敗した内容についてはファイルをダウンロードし\nその内容を再確認してください。';
    export const ERR_PDF_DOWNLOAD = 'PDFのダウンロードに失敗しました。';
    export const ERR_TENANT_NO = '※団体番号が一致しません';
    export const ERR_USER_IDCARD_PDF_ACCOUNT = '利用者が停止状態です。';
    export const ERR_USER_IDCARD_PDF_LAST_NAME = '利用者名が設定されていません。';
    export const ERR_UPDATE_DATA = 'データの更新に失敗しました。';
    export const SUCCESS_SEND_MAIL = 'メールの送信が完了しました。';
    export const ERR_SEND_MAIL = 'メールの送信に失敗しました。';
    export const IMPORT_ERR_OVERLAP_USER_NUMBER = '重複している利用者番号';
    export const IMPORT_ERR_USER_ACCOUNT = '停止状態の利用者番号';
    export const ERR_USER_IDCARD_PDF_UNDEFINED_ID = '存在しない利用者番号です。';
    export const ERR_NONE_INPUT_ID = '利用者番号の入力がありません。';
    export const ERR_GET_DATA = 'データの取得に失敗しました。';
    export const ERR_SEARCH_ITEM_INPUT_REQUIRED = '検索項目を1つ以上入力してください。'
    export const ERR_SEARCH_ITEM_INPUT_REQUIRED1 = '検索項目と一致する利用者が見つかりません。'
    export const ERR_SEARCH_RESULT_ITEM_EMPTY = '検索結果が0件の時は履歴出力できません。'
    export const POINT_HISTORY_EXPORT_TITLE = 'ポイント履歴出力確認';
    export const SELECTION_REQUIRED = '選択してください。';
    export const ERR_CSV_EXPORT = 'CSVファイルのダウンロードに失敗しました。';
    export const ERR_EXCEL_EXPORT = 'Excelファイルのダウンロードに失敗しました。';
    export const IMPORT_ERR_REGISTRATION_INFORMATION = '役割が利用者の場合、ポイント管理を利用可にできません';
    export const IMPORT_ERR_USER_ID_NOT_EXIST = '利用者IDが存在しません';
    export const IMPORT_ERR_USER_ACCOUNTSUSPENSION = '利用停止中です';
    export const IMPORT_ERR_NOT_FOUD_USER_LAST_NAME = '利用者名が登録されていません';
    export const IMPORT_ERR_AFFILIATION_GROUP = '対象グループに所属していません';
    export const IMPORT_ERR_GROUP_ID_NOT_EXIST = 'グループIDが存在しません';
    export const IMPORT_ANNOTATION_GROUP_NAME = 'グループ名が変更されています';
    export const ERR_INVALID_VALUE = '無効な値です。';
    export const ERR_NOT_HALFWIDTH_DIGIT = '半角数字で入力してください。';
    export const ERR_NOT_6_DIGITS = '1～6桁の数字を入力してください。';
    export const ERR_NOT_5_DIGITS = '1～5桁の数字を入力してください。';
    export const ERR_NOT_2_DIGITS = '1～2桁の数字を入力してください。';
    export const ERR_NOT_NUMERIC_OR_MORE_1 = '1以上の数字を入力してください。';
    export const WARN_MINUS_POINT = '保有ポイント数が0ポイントになります。';
    export const SUCCESS_SAVE_DATA = '%1を保存しました。';
    export const ERR_UNEXPECTED = 'エラーが発生しました。';
    export const ERR_APP_AVAILABLE_OVER_USER = 'アプリ利用「利用可」の契約数上限（%1）を超えています。';
    export const ERR_APP_NOT_AVAILABLE_OVER_USER = 'アプリ利用「利用不可」の契約数上限（%1）を超えています。';
    export const ERR_STATUS_OVERLAP = 'ステータスの有効期間が重複しています。';
    export const ERR_POINT_NAME_DUPLICATION = 'このポイント名は既に登録されています。';
    export const POINT_SETTING_DELETE_TITLE = 'ポイント設定削除';
    export const POINT_SETTING_DELETE_TEXT = '削除してもよろしいですか？';
    export const REGIST_MODAL_TEXT = '登録してもよろしいですか？';
    export const POINT_ADJUSTMENT_TITLE = 'ポイント調整';
    export const POINT_ADJUSTMENT_SHORTAGE = '保有ポイント不足　ポイント数（%1）';
    export const ERR_GRANTPOINTS_NUMBER = '0以外の数値を入力してください。';
    export const ERR_NOT_INTEGER = '整数で入力してください。';
    export const ERR_NOT_ADD_POINT_SETTINGS = 'ポイント設定がされていません。';
    export const ERR_USER_ACCOUNT_SUSPENSION = '利用停止中のため保存できませんでした。';
    export const ERR_LOGIN_INFO_PDF_NO_DATA = "ログイン可能な利用者がいないためダウンロードできません。";
    export const ERR_EXPORT_HISTORY_NO_DATA = "出力対象の履歴がないためダウンロードできません。";
    export const ERR_OPTION_SETTING_USER_NO_DATA = "利用者情報が登録されていないためダウンロードできません。";
    export const ERR_VALID_NUMBER = '%1以上の数字を入力してください。';
};

// 定数
export module ConstValue {
    export const IMG_MAX_FILE_SIZE = 500000; // KB
    export const IMG_MAX_WH = 1920; // px
    export const appTheme: Object = [
        { id: "none", name: "なし" },
        { id: "orange", name: "橙" },
        { id: "purple", name: "紫" },
        { id: "blue", name: "青" },
        { id: "pink", name: "ピンク" },
        { id: "red", name: "赤" },
    ]; // アプリテーマ
    export const lightColor: ColorSet[] = [
        { colorName: 'pink', className: 'bg-[#FFB7E5]', hex: '#FFB7E5' },
        { colorName: 'purple', className: 'bg-[#E8B7FF]', hex: '#E8B7FF' },
        { colorName: 'blue', className: 'bg-[#B7D0FF]', hex: '#B7D0FF' },
        { colorName: 'light-blue', className: 'bg-[#B7F1FF]', hex: '#B7F1FF' },
        { colorName: 'green', className: 'bg-[#B7FFC5]', hex: '#B7FFC5' },
        { colorName: 'yellow', className: 'bg-[#FFFFB7]', hex: '#FFFFB7' },
        { colorName: 'orange', className: 'bg-[#FFDEB7]', hex: '#FFDEB7' },
        { colorName: 'red', className: 'bg-[#FFBDB7]', hex: '#FFBDB7' },
        { colorName: 'white', className: 'bg-[#FFFFFF]', hex: '#FFFFFF' }
    ]; // テーマカラー:lightColor  薄い配色[ピンク、紫、青、水色、緑、黄色、オレンジ、赤]
    export const darkColor: ColorSet[] = [
        { colorName: 'pink', className: 'bg-[#CE3797]', hex: '#CE3797' },
        { colorName: 'purple', className: 'bg-[#9437CE]', hex: '#9437CE' },
        { colorName: 'blue', className: 'bg-[#3D37CE]', hex: '#3D37CE' },
        { colorName: 'light-blue', className: 'bg-[#2C89D8]', hex: '#2C89D8' },
        { colorName: 'green', className: 'bg-[#009E18]', hex: '#009E18' },
        { colorName: 'yellow', className: 'bg-[#949A00]', hex: '#949A00' },
        { colorName: 'orange', className: 'bg-[#C18600]', hex: '#C18600' },
        { colorName: 'red', className: 'bg-[#CE3737]', hex: '#CE3737' },
        { colorName: 'white', className: 'bg-[#FFFFFF]', hex: '#FFFFFF' }
    ]; // テーマカラー:darkColor  濃い配色[ピンク、紫、青、水色、緑、黄色、オレンジ、赤]
};

/** ポイントカテゴリID */
export module PointCategoryId {
    /** ボランティアポイント */
    export const VOLUNTEER: number = 0;
    /** 各種ポイント */
    export const VARIOUS: number = 1;
    /** アプリポイント */
    export const APP: number = 2;
};

/** ポイントタイプID */
export module PointTypeId {
    /** ボランティア団体登録 */
    export const VOLUNTEER_REGIST = "00-00";
    /** ボランティア活動参加 */
    export const VOLUNTEER_ACTIVITY = "00-01";
    /** ボランティア講座参加 */
    export const VOLUNTEER_COURSE = "00-02";
    /** イベント参加 */
    export const EVENT_PARTICIPATION = "01-00";
    /** その他 */
    export const OTHER = "01-01";
    /** 団体登録 */
    export const GROUP_REGIST = "01-02";
    /** 指定歩数到達 */
    export const STEPS_SPECIFIED = "02-00";
    /** 目標歩数到達毎 */
    export const STEPS_TARGET = "02-01";
    /** 歩数範囲毎 */
    export const STEPS_RANGE = "02-02";
    /** バイタル登録 */
    export const VITAL_REGIST = "02-03";
    /** 初回ログイン */
    export const FIRST_LOGIN = "02-04";
    /** お知らせ閲覧 */
    export const READ_MESSAGE = "02-05";
    /** アプリ起動 */
    export const LAUNCH_APP = "02-06";
    /** 動画閲覧 */
    export const VIEW_MOVIE = "02-07";
};

/** ボーナスポイント条件名 */
export module BonusSettingsCondition {
    /** 連続（日）: {}日連続 */
    export const SEQ_DAY = '%1日連続';
    /** 連続（週）: {}週連続 */
    export const SEQ_WEEK = '%1週連続';
    /** 連続（月）: {}ヵ月連続 */
    export const SEQ_MONTH = '%1ヵ月連続';
    /** 連続（回数）: {}回連続 */
    export const SEQ_COUNT = '%1回連続';
    /** 期間（日）: {}日間で{}回 */
    export const PERIOD_DAY = '%1日間で%2回';
    /** 期間（週）:{}週間で{}回 */
    export const PERIOD_WEEK = '%1週間で%2回';
    /** 期間（月）{}ヵ月間で{}回 */
    export const PERIOD_MONTH = '%1ヵ月間で%2回';
    /** 期間（範囲）:{} ～ {} の期間で {}回 */
    export const PERIOD_RANGE =  '%1 ～ %2 の期間で %3回';
    /** 合計（回数）：{}回 */
    export const SUM_COUNT = '%1回';
}

// セッションキー
export module SessionKey {
    export const HAS_DUPLICATED_STAFF_MAIL = 'hasDuplicatedStaffMail';
    export const SIDEBAR_STATE = 'sidebarState';
    export const USER_ID_CARD_AUTH = 'userIdCardAuth';
    export const MANAGE_POINT_AUTH = 'managePointAuth';
    export const OPTION_CONTRACT_LIST = 'optionContractList';
};

/** 作成元種別 */
export module CreateUserType {
    /** 運営者 */
    export const ADMIN = 'admin';
    /** 団体管理者 */
    export const MUNICIPALITY = 'municipality';
};

/** 作成元種別名 */
export module CreateUserName {
    /** 運営者 */
    export const ADMIN = '運営';
    /** 団体管理者 */
    export const MUNICIPALITY = '団体';
};

/** 接頭辞 */
export module Prefix {
    /** Excel取込エラー */
    export const XLSX_IMPORT_ERROR = '取込エラー_';
};
